<template>
    <div class="card border-top-0">
        <div class="card-body personal-info">
            <div class="mb-4 d-flex align-items-center justify-content-between">
                <h5 class="fw-bold mb-0 me-4">
                    <span class="d-block mb-2">Paketleme:</span>
                    <span class="fs-12 fw-normal text-muted text-truncate-1-line">İlacın paketleme şekillerini
                        buradan düzenleyebilirsiniz.</span>
                </h5>
                <div class="d-flex gap-2">
                    <button @click="addPackage()" class="btn btn-lg btn-light-brand bg-green text-white">Paket
                        Ekle</button>
                </div>
            </div>
            <div class="d-flex" v-if="medicine_packages.length > 0">
                <table class="table">
                    <thead>
                        <tr>
                            <th>Adet</th>
                            <th>Birim</th>
                            <th>Üst Birim</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(pack, index) in medicine_packages" @click.prevent="activePackageIndex = index">
                            <td>{{ pack.contains_units }}</td>
                            <td>{{ pack.parent_label }}</td>
                            <td>1 {{packages.find(unit => unit.value ===
                                pack.package_type).label}}</td>
                            <td>
                                <a href="#" @click="medicine_packages.splice(index, 1)"
                                    v-if="index === medicine_packages.length - 1" class="avatar-text avatar-md bg-red">
                                    <i class="feather-delete fs-16"></i>
                                </a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="row mb-4 align-items-center" v-if="medicine_packages.length > 0">
                <div class="col-1">
                    <div class="input-group">
                        <input type="text" class="form-control" v-model="lastPackage.contains_units">
                    </div>
                </div>
                <div class="col-2">
                    <label class="fw-semibold">{{ lastPackage.parent_label
                    }}</label>
                </div>
                <div class="col-1">
                    <label class="fw-semibold">1</label>
                </div>
                <div class="col-2">
                    <div class="input-group">
                        <select name="unit" class="form-select form-select-sm" v-model="lastPackage.package_type">
                            <option v-for="pack in packages" :key="pack.value" :value="pack.value">
                                {{ pack.label }}</option>
                        </select>
                    </div>
                </div>
                <div class="col-2">
                    <span class="fw-semibold">içerisindedir.</span>
                </div>

            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'MedicinePackage',
    props: {
        medicine: {
            type: Number,
            required: false,
        },
        selectedUnitLabel: {
            type: String,
            required: true,
        },
        existing_packages: {
            type: Array,
            required: false,
        },

    },
    data() {
        return {
            medicine_packages: [],
            packages: [],
            activePackageIndex: null,
        }
    },
    watch: {
        medicine_packages: {
            deep: true,
            handler(newVal) {
                console.log('newVal: ', newVal);
                this.$emit('update:medicinePackages', newVal);
            }
        }
    },
    computed: {
        lastPackage() {
            return this.medicine_packages[this.medicine_packages.length - 1];
        }
    },
    async mounted() {
        await this.fetchPackages();
        console.log('medicineId in medicinePackage', this.medicine);
        console.log('existing_packages in medicinePackage', this.existing_packages);
        if (this.medicine && this.existing_packages) {
            this.existing_packages.forEach((pack, index) => {
                if (index === 0) {
                    pack.parent_label = this.selectedUnitLabel;
                } else {
                    pack.parent_label = this.packages.find(unit => unit.value === this.existing_packages[index - 1].package_type).label;
                }
            });
            this.medicine_packages = this.existing_packages;
        }
    },
    methods: {
        async fetchPackages() {
            try {
                const response = await this.$axios.get('package_type_choices/');
                this.packages = response.data;
            } catch (error) {
                Swal.fire('Hata', error, 'error');
            }
        },
        addPackage() {
            if (this.medicine_packages.length == 0) {
                console.log('length is 0')
                this.medicine_packages.push({
                    parent_label: this.selectedUnitLabel,
                    contains_units: '',
                    package_type: this.packages[0].value,
                });
            } else {
                console.log('length is not 0')
                const result = this.packages.find(unit => unit.value === this.medicine_packages[this.medicine_packages.length - 1].package_type).label;
                this.medicine_packages.push({
                    parent_label: result,
                    contains_units: '',
                    package_type: this.packages[0].value,
                });
            }
            this.activePackageIndex = this.medicine_packages.length - 1;
        },
    }
}
</script>